/**
 * Dependencies
 */
import http from '../../../../services/HttpService'

/**
 * Submit a new generated table module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
const submit = ({ commit, dispatch, rootState, state }) => {
    let action = 'domAlt/createComponent'
    let data = getPostData(rootState, state)
    let options = { root: true }
    commit('SET_LOADING')
    commit('RESET_ERROR')
    dispatch(action, data, options)
        .then(res => {
            commit('RESET_LOADING')
        })
        .catch(() => {
            commit('SET_ERROR')
            commit('RESET_LOADING')
        })
}

/**
 * Create a new rent comp
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {FormData} payload
 * @return {Promise}
 */
const createComp = ({ commit, dispatch }, payload) => new Promise((resolve, reject) => {
    commit('SET_LOADING')
    commit('RESET_ERROR')
    http.post(`comps/dashboard/${payload.type}/`, payload.data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
        commit('RESET_LOADING')
        dispatch('addNotification', {
            title: res.data.message,
            text: 'Your comp has been saved and is available for selection.',
            type: 'success',
            timeout: 3000
        }, { root: true })
        resolve(res.data)
    })
    .catch(err => reject(err))
})

const deleteRentComp = ({ commit, rootState }, payload) => {
    let page = rootState.dom.newComponent.context.page
    let position = rootState.dom.newComponent.context.position
    http.del(`comps/${payload.comp.id}`)
        .then(res => {
            commit('DELETE_RENT_COMP', {
                page,
                position,
                index: payload.index
            })
        })
}

const fetchRentComps = ({ commit, dispatch }) => {
    return http.get(`comps/dashboard/rent`)
        .then(res => {
            commit('FETCH_RENT_COMPS', res.data)
        })
}

const updateExistingRentComp = ({ commit, dispatch }, payload) => {
    console.log('hello there')
}

const addNewComp = ({ commit, dispatch }, payload) => {
    commit('SET_LOADING')
    commit('RESET_ERROR')
    commit('RESET_LOADING')
    dispatch('dom/newComponent/toggleModal', null, { root: true })
}

const updateExistingComp = ({commit}) => {
    console.log('update!')
}

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
const getPostData = (rootState, state) => {
    let page = rootState.dom.newComponent.context.page
    let position = rootState.dom.newComponent.context.position
    return {
        type: 'comp-set',
        component: { page: page },
        model: {
            position: position,
            value: {
                'title': null,
                'comp_ids': null,
                'selected_fields': [
                    'address',
                    'total_sqft',
                    'total_units',
                    'weighted_avg_rent',
                    'rent_per_sqft',
                    'occupancy',
                    'year_built',
                    'year_renovated',
                    'notes'
                ]
            }
        }
    }
}

/**
 * Select an option and persist the component state
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {String} option
 * @return {Promise}
 */
const selectOption = ({ commit, dispatch }, option) => commit('SELECT_OPTION', option)

export default {
    submit,
    selectOption,
    fetchRentComps,
    createComp,
    deleteRentComp,
    updateExistingRentComp,
    addNewComp,
    updateExistingComp
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-compset/actions.js